// function initEventHandlers() {
//     var $videoFeatureBtn = $('.whats-inside__btn-play');
//     $videoFeatureBtn.on('click', playVideo);
// }

// function playVideo() {
//     var src = $(this).attr('data-video');
//     var video = '<div class="iframe-container video-iframe"><iframe src="' + src + '"frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" title="Lofoten from Above" data-ready="true"></iframe></div>';
//     $(this).replaceWith(video);
// }

function addOrderToSections() {
    if($(window).width() <= 767) {
        if(!$('.whats-inside__main-image').hasClass('whats-inside__main-image-order')) { $('.whats-inside__main-image').addClass('whats-inside__main-image-order'); }
        if(!$('.whats-inside__main-text').hasClass('whats-inside__main-text-order')) { $('.whats-inside__main-text').addClass('whats-inside__main-text-order'); }
    } else {
        $('.whats-inside__main-image').removeClass('whats-inside__main-image-order');
        $('.whats-inside__main-text').removeClass('whats-inside__main-text-order');
    }
}

$(function () {
    // initEventHandlers();
    addOrderToSections();
});

$(window).resize(function () {
    addOrderToSections();
});
